<template>
  <div class="sp-template">
    <!-- 从提成页面复制 commission.vue -->
    <div class="h-title">订单预警</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">

        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">

          <el-row>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model="conditions.orderIdText" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>

            <!-- <el-form-item label="开始时间" label-width="100px">
              <el-date-picker v-model.lazy="conditions.startDate" type="date" value-format="yyyy-MM-dd"
                placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" label-width="100px">
              <el-date-picker v-model.lazy="conditions.endDate" type="date" value-format="yyyy-MM-dd"
                placeholder="结束日期"></el-date-picker>
            </el-form-item> -->

          <!-- </el-row>
          <el-row> -->
            <el-form-item label="客户">
              <el-select v-model="conditions.orgOwner" filterable clearable placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="问题件类型" >
              <el-select v-model.lazy="conditions.type" filterable clearable >
                <el-option v-for="(d, i) in typelist" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="创建时间">
              <el-date-picker
              v-model.lazy="daterange1"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"                
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="处理进度" >
              <el-select v-model.lazy="conditions.processStatus" filterable clearable >
                <el-option v-for="(d, i) in processStatusList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="备注类型">
              <el-select v-model.lazy="conditions.remarksType" filterable clearable >
                <el-option v-for="(d, i) in remarksTypeList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="客服" v-show="!isKefu">
              <el-select v-model.lazy="conditions.customerServiceStaff" filterable clearable >
                <el-option v-for="(d, i) in customerServiceStaffs" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <div class="search-form__buttons">
                <el-button type="primary" size="small" @click="searchTask">搜 索</el-button>
              </div>
            </el-form-item>

          </el-row>
          <!-- <el-row></el-row> -->

        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="searchTask">
          <el-tab-pane label="待操作处理" name="0"></el-tab-pane>
          <el-tab-pane label="待客服处理" name="1"></el-tab-pane>
          <el-tab-pane label="已处理" name="2"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button size="small" @click="popEditBatch()" v-if="in_configs(110101)" v-show="conditions.status==0 || conditions.status==1">编辑</el-button>

          <el-button size="small" @click="exportAll()">导出</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border  style="width: 100%"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column prop="batchId" label="批次号"></el-table-column>
        <!-- <el-table-column prop="trackingNumber" label="转单号"></el-table-column> -->
        <el-table-column label="转单号">
          <template slot-scope="scope">

            <a v-if="scope.row.trackingNumber && scope.row.trackingNumber.indexOf('1Z')!=-1 " target="_blank" style="border-bottom:1px solid;" :href="'https://www.ups.com/track?loc=en_US&tracknum='+scope.row.trackingNumber+'&requester=WT/trackdetails'" >{{scope.row.trackingNumber}}</a>
            <!-- <a v-else-if="scope.row.customerRefnumber.trackingNumber && channelMap[scope.row.productId] && channelMap[scope.row.productId].search(/fedex/i) >=0" target="_blank" style="border-bottom:1px solid;" :href="'https://www.fedex.com/apps/fedextrack/?tracknumber='+scope.row.customerRefnumber.trackingNumber" >{{scope.row.customerRefnumber.trackingNumber}}</a> -->
            <span v-else >{{scope.row.trackingNumber}}</span>     
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="问题件类型">
          <template slot-scope="scope">
            {{typemaps[scope.row.type]}}
          </template>
        </el-table-column>
        <el-table-column label="处理进度">
          <template slot-scope="scope">
            {{processStatusMap[scope.row.processStatus]}}
          </template>
        </el-table-column>        
        <el-table-column prop="createdAt" label="创建时间"></el-table-column>
        <el-table-column prop="updatedAt" label="最后编辑时间"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>

        <el-table-column label="操作" v-if="conditions.status==0 || conditions.status==1 ">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="popEdit(scope.row)"  v-if="in_configs(110101)" > 编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="conditions.currentPage" :page-sizes="[10, 50, 100, 500, 2000, 10000]" :page-size.sync="conditions.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

  
    <el-dialog title="编辑" :visible.sync="dialogEditVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" label-width="100px">

        <el-form-item label="状态">
          <el-select v-model.lazy="editData.status" filterable clearable >
            <el-option v-for="(d, i) in statuslist" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理进度">
          <el-select v-model.lazy="editData.processStatus" filterable clearable >
            <el-option v-for="(d, i) in processStatusList" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注类型">
          <el-select v-model.lazy="editData.remarksType" filterable clearable >
            <el-option v-for="(d, i) in remarksTypeList" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" v-if="editData.remarksType==5">
          <el-input type="textarea" v-model.lazy="editData.remarks"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogEditVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="editSubmit()">确 定</el-button>
      </div>
    </el-dialog>

  </div>




</template>

<script>
import { base64ToUint8Array, dateFormat, pickerOptions } from '@/util/formUtil'
  import { mapState, mapMutations } from "vuex";
  export default {
    data() {
      return {
        remarksTypeList: [{"name":"公司定价低","id":0},{"name":"单独报价低","id":1},{"name":"快递成本高","id":2},{"name":"渠道混装","id":3},{"name":"货型","id":4},{"name":"其它","id":5}],
        remarksTypeMap: {"0":"公司定价低","1":"单独报价低","2":"快递成本高","3":"渠道混装","4":"货型","5":"其它"},
        processStatusList: [{"name":"未处理","id":0},{"name":"未到仓","id":1},{"name":"已到仓","id":2},{"name":"重派","id":3},{"name":"销毁","id":4},{"name":"赔偿","id":5},{"name":"已核实","id":6}],
        processStatusMap: {"0":"未处理","1":"未到仓","2":"已到仓","3":"重派","4":"销毁","5":"赔偿","6":"已核实"},
        daterange1: "",
        pickerOptions: pickerOptions,
        customerServiceStaffs: [],
        isKefu: false, 
        // ,{"name":"派送延误","id":6},{"name":"超时提取（送仓时间当天开始算第5天）","id":7},{"name":"超时签收（提取时间当天开始算第8天）","id":8}
        typelist: [{"name":"亏损异常（应收费用-实际成本<0）","id":1},{"name":"退件","id":2},{"name":"拒收","id":3},{"name":"破损","id":4},{"name":"恶劣天气","id":5},{"name":"毛利率偏高","id":9}],
        // ,"6":"派送延误","7":"超时提取","8":"超时签收"
        typemaps: {"1":"亏损异常","2":"退件","3":"拒收","4":"破损","5":"恶劣天气","9":"毛利率偏高"},
        statuslist: [{"id":0,"name": "待操作处理"},{"id":1,"name": "待客服处理"},{"id":2,"name": "已处理"}],
        customers: [],
        customerMaps: {},

        sumbitForm: {
          categoryId: "",
          kindId: "",
          supplierId: ""
        },
        dialogCheckVisible: false,
        tableData: [],
        batchOrderIds: [],
        multipleSelection: [],

        conditions: {
          which: 1,
          orderIdText: '',
          startDate: "",
          endDate: "",
          orgOwner: "",
          status: 0,
          customerServiceStaff: "",
          type: "",
          processStatus: '',
          remarksType: '',
          currentPage: 1,
          pageSize: 10
        },

        dialogEditVisible: false,
        editData: {
          "which": 1,
          "ids": [],
          "status": 0,
          "remarks": "",          
          processStatus: '',
          remarksType: ''
        },
        total: 0
      };
    },
    components: {},
    created() {
      setTimeout(() => {

        let _this = this;
        let urlArray = [
          this.findAllCustomerName(),
        ];

        this.$axios.all(urlArray).then(
          this.$axios.spread(function (customerData) {
            _this.initCustomerData(customerData);
            _this.loadRoleList("客服");

            _this.query();
          })
        );



      }, 1000);
    },
    methods: {
      ...mapMutations([
        "setManualTrackingNumbers",
        "setOrderListTable",
        "setOrderListConditions",
        "setOrderListSearchMore"
      ]),
      formatRefNumber(refNumber) {
        let arr = refNumber;
        arr.forEach((item, index) => {
          if (item === " " || item === ",") {
            arr.splice(index, 1);
          }
        });
        return arr;
      },
     
      //查询客户
      findAllCustomerName() {
        return this.$request1.get(
          '/customerAll',
          {
            withCredentials: true
          }
        );
      },
      
      initCustomerData(data) {
        let _this = this;
        if (data.data.success) {
          _this.customers = data.data.data;
          if (_this.customers.length > 0) {
            _this.customers.forEach(c => {
              _this.customerMaps[c.id] = c.name;
            });
          }
        }
      },
      searchTask() {
        this.conditions.currentPage = 1;
        this.query();
      },
      query() {
        let _this = this;

        this.conditions.orderIds = [];
        if (this.conditions.orderIdText) {
          this.conditions.orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
        }
        this.conditions.export = 0
        this.conditions.startDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[0] : ""
        this.conditions.endDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[1] : ""

        this.$request1({
          method: 'post',
          url: '/alarm/query',
          data: _this.conditions,
          withCredentials: true,
          header: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            if (response.data.success) {
              this.tableData = response.data.data.list;
              this.total = response.data.total;
              this.isKefu = response.data.data.kefu;
              
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      // 批量编辑弹框
      popEditBatch() {
        let _this = this
        let t = '编辑'
        // console.log(this.multipleSelection.length);
        if (this.multipleSelection.length == 0) {
          this.$message.error(`请勾选要${t}的数据`);
          return;
        }
        this.dialogEditVisible = true;
        this.editData.status = null
        this.editData.remarks = ""
        this.editData.processStatus = ""
        this.editData.remarksType = ""
        this.editData.ids = this.multipleSelection.map(a => a.id).filter(a => a)
      },

      popEdit(row) {
        this.dialogEditVisible = true;

        this.editData.ids = [row.id]
        this.editData.status = ""
        this.editData.processStatus = row.processStatus
        this.editData.remarksType = row.remarksType
        this.editData.remarks = row.remarks

      },
      editSubmit() {
        let _this = this;
        
        // 非其他
        if(this.editData.remarksType && this.editData.remarksType!='5'){
          this.editData.remarks = this.remarksTypeMap[this.editData.remarksType]
        }

        this.$request1
          .post(
            '/alarm/update',
            _this.editData,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(function (response) {
            if (response.data.success) {
              _this.$message.success("提交成功");
              _this.dialogEditVisible = false
              _this.query();

            } else {
              _this.$message.error(response.data.message);
            }
          });

      },
      // 改变险种
      changeCategory(categoryId) {
        let _this = this;
        console.log("categoryId===>", categoryId);
        this.kinds = _this.categoryMap[categoryId]
        _this.kindId = "";
      },
      exportAll() {
        let _this = this;

        // var url = tmsSpringUrl + '/alarm/query';

        // var form = document.createElement("form");
        // form.method = "post";
        // form.action = url;
        // form.target = "_blank";
        // document.body.appendChild(form);


        if (this.conditions.orderIdText) {
          let orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
          // orderIds.forEach(a => {
          //   var input = document.createElement("input");
          //   input.type = "hidden";
          //   input.name = "orderIds[]";
          //   input.value = a;
          //   form.appendChild(input);
          // })
        }

        this.conditions.export = 1
        this.conditions.startDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[0] : ""
        this.conditions.endDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[1] : ""

        this.$request1({
          url: '/alarm/query',
          method: 'post',
          data: this.conditions
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            this.conditions.export = 0
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `alarm_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })

      //   Object.keys(this.conditions).forEach(key => {
      //     if(key != 'orderIds' ){
      //       var input1 = document.createElement("input");
      //       input1.type = "hidden";
      //       input1.name = key;
      //       input1.value = this.conditions[key];
      //       form.appendChild(input1);
      //     }
      //   })

      //   var input2 = document.createElement("input");
      // input2.type = "hidden";
      // input2.name = "token";
      // input2.value = this.$getToken()
      // form.appendChild(input2);

      //   form.submit();

      },
      //查询业务员和客服
    loadRoleList(role) {
      let _this = this;
      _this.$request1
        .get(
          '/staffrole',
          {
            params: {
              role: role
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (role == "业务员") {
              _this.salesmans = res.data.data;
            } else if (role == "客服") {
              _this.customerServiceStaffs = res.data.data;
            }
          } else {
            _this.salesmans = [];
            _this.customerServiceStaffs = [];
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

      //多选按钮
      handleSelectionChange(val) {
        // console.log(">>>val=", val);
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.conditions.currentPage = 1;
        this.conditions.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.conditions.currentPage = val;
        this.query();
      },
      dateFormat(date, fmt) {
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
          "H+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds() //毫秒
        };
        var week = {
          "0": "/u65e5",
          "1": "/u4e00",
          "2": "/u4e8c",
          "3": "/u4e09",
          "4": "/u56db",
          "5": "/u4e94",
          "6": "/u516d"
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        if (/(E+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1
              ? RegExp.$1.length > 2
                ? "/u661f/u671f"
                : "/u5468"
              : "") + week[date.getDay() + ""]
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      }
    }
  };
</script>

<style>
  .el-message-box__message p {
    margin: 0;
    line-height: 24px;
    white-space: pre-wrap !important;
  }

  .el-range-separator{
    width: 20px !important;
    font-size: 10px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/alarm/alarm_order.vue